import { useQueryClient } from '@tanstack/react-query';
import { useStore, useStoreActions } from '~/contexts';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
import { revenueOpportunitiesListKey } from '~/utils/revenueOpportunities/revenueOpportunitiesQueryKeys';
export const useRevenueOpportunitiesList = function useRevenueOpportunitiesList(query) {
    let { refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const businessId = useStore(selectors.user.businessId);
    const queryKey = revenueOpportunitiesListKey(businessId !== null && businessId !== void 0 ? businessId : null, query);
    const { data, isLoading, isFetching, isPreviousData, error, refresh } = useQueryState({
        queryKey,
        queryFn: ()=>api.pulse.getList(query),
        enabled: businessId != null,
        refreshOnHookMount,
        keepPreviousData: true
    });
    function readListState() {
        const state = queryClient.getQueryState(queryKey);
        return {
            list: state === null || state === void 0 ? void 0 : state.data,
            isFetching: (state === null || state === void 0 ? void 0 : state.fetchStatus) === 'fetching'
        };
    }
    return {
        list: data,
        isShowingPreviousAnswer: isPreviousData,
        isLoading,
        isFetching,
        error,
        refresh,
        readListState
    };
};
